// Which saved view the list is previewing, for the filter bar, the primary
// strip and the chart area to paint as a preview. A store, so no page component
// has to thread it through: the list writes it from inside a portaled popover.
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { openReplayStateLogger } from '../../../../hooks/open-replay';
import type { FilterLine } from '../../filters/utils/describeFilterMap';

export type SavedViewPreview = {
  name: string;
  lines: FilterLine[];
};

type SavedViewPreviewState = {
  preview: SavedViewPreview | null;
  setSavedViewPreview: (preview: SavedViewPreview | null) => void;
};

const useSavedViewPreviewStore = create<SavedViewPreviewState>()(
  devtools(
    openReplayStateLogger(
      (set) => ({
        preview: null,
        setSavedViewPreview: (preview) => set({ preview }),
      }),
      'saved_view_preview'
    ),
    { name: 'SavedViewPreview' }
  )
);

export const useSavedViewPreview = (): SavedViewPreview | null =>
  useSavedViewPreviewStore((state) => state.preview);

export const setSavedViewPreview = (preview: SavedViewPreview | null) =>
  useSavedViewPreviewStore.getState().setSavedViewPreview(preview);
